var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightbulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.09 2.82002C15.2274 1.2881 12.7731 0.67819 10.41 1.16002C7.23261 1.80183 4.75657 4.29762 4.14001 7.48002C3.69428 9.84222 4.32484 12.2802 5.86001 14.13C6.56369 14.9241 6.96704 15.9395 7.00001 17V20C7.00001 21.6569 8.34315 23 10 23H14C15.6569 23 17 21.6569 17 20V17.19C17.0336 16.0192 17.4637 14.8944 18.22 14C20.978 10.5884 20.4739 5.59202 17.09 2.80002V2.82002ZM15 20C15 20.5523 14.5523 21 14 21H10C9.44772 21 9.00001 20.5523 9.00001 20V19H15V20ZM16.67 12.76C15.6645 13.9526 15.0779 15.4421 15 17H13V14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V17H9.00001C8.97362 15.4681 8.40695 13.9948 7.40001 12.84C6.04859 11.2208 5.64656 9.01097 6.3411 7.01955C7.03563 5.02813 8.72475 3.5476 10.79 3.12002C12.557 2.75619 14.394 3.20678 15.7921 4.34697C17.1902 5.48717 18.001 7.19593 18 9.00002C18.0074 10.3699 17.5371 11.6995 16.67 12.76Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default ForwardRef;